<div class="button-container">
  Categoria:
  @for (cat of listCatArt; track cat) {
    <dx-button
      stylingMode="contained"
      [id]="cat.id"
      [text]="getTitleButton(cat.id,cat.descrizione)"
      [type]="selectedCat === cat.id ? 'success' : 'default'"
      width="120"
      (onClick)="filterByCategory(cat.id)">
    </dx-button>
  }

  <dx-button
    stylingMode="contained"
    id="0"
    [text]="getTitleButton(0,'Tutti')"
    [type]="selectedCat === 0 ? 'success' : 'default'"
    width="120"
    (onClick)="filterByCategory(0)"
  ></dx-button>

  Solo Articoli Attivi<dx-check-box [(value)]="attivi" (onValueChanged)="onAttiviChanged($event)"></dx-check-box>
</div>